import { type ProductInfoCard } from 'types/model'
import { useInventoryProductsList } from './InventoryProductList.hook'
import {
  AtlasBodyMain,
  AtlasBodySubtitle,
  AtlasColor,
  AtlasListAtom,
  CardComponent,
  CardDivider,
  CardRow,
  Icon,
  Icons,
  PageContentAtom,

  StackAtom,

  ToolbarMolecule
} from '@justomx/atlas-components'
import './InventoryProductList.css'
import LoaderAtom from 'components/atoms/Loader.atom'
import { useTranslation } from 'react-i18next'
import ProductInfoAtom from 'components/atoms/v2/ProductInfo.atom'
import { TextfieldDialogOrganism } from 'components/organisms/TextfieldDialog.organism'

export const InventoryProductListPage = () => {
  const {
    actions,
    filteredProducts,
    isLoading,
    origin,
    searchProductDialogRef
  } = useInventoryProductsList()
  const { t } = useTranslation('global')

  const toScanProduct = actions.goToScanProduct
  const back = actions.back

  if(isLoading) {
    return <LoaderAtom>{t('loader.message')}</LoaderAtom>
  }

  return <>
    <ToolbarMolecule
      title="Productos"
      actionIcon={Icons.IcCancelIcon}
      secondaryActionIcon={Icons.IcScanIcon}
      thirdActionIcon={Icons.IcKeyboardIcon}
      onAction={back}
      onSecondaryAction={toScanProduct}
      onThirdAction={actions.openSearchProductDialog}
      data-test="inventory-product-list-toolbar"
    />
    <PageContentAtom>
      <CardComponent $variant="highlight" style={{ gap: 4 }}>
        {origin.container?.name && <CardRow>
          <Icon src={Icons.IcPallet} size={18} />
          <AtlasBodySubtitle>{origin.container.name}</AtlasBodySubtitle>
        </CardRow>}
        <CardRow>
          <Icon src={Icons.IcUbicacionIcon} size={18} />
          <AtlasBodySubtitle>{origin.location?.name}</AtlasBodySubtitle>
        </CardRow>
      </CardComponent>

      <AtlasBodySubtitle>Instrucciones</AtlasBodySubtitle>
      <AtlasListAtom style={{listStyleType: 'decimal'}}>
        <li ><AtlasBodyMain display="contents">Escanea el producto para corregir su inventario.</AtlasBodyMain></li>
      </AtlasListAtom>

      {filteredProducts.length === 0 ? <InventoryProductListEmpty /> : ''}

      <StackAtom gap={12} style={{ marginTop: 16 }}>
      {filteredProducts.map((e,i) => {
        const productInfo: ProductInfoCard = {
          ean: e.productEan,
          sku: e.productSku,
          name: e.productName,
          stock: e.stock,
          zone: e.productZone as string,
          isWeighable: false,
          image: e.productImage as string,
        }
        return <>
        <CardComponent
          key={`${e.productEan}-${i}`}
          color={AtlasColor.Neutral40}
          style={{
            backgroundColor: AtlasColor.BackgroundInformative1,
            border: 'none'
          }}
        >
          <CardRow $gap={16}>
            <ProductInfoAtom product={productInfo} />
          </CardRow>
        </CardComponent>
        <CardDivider/>
        </>
      })}
      </StackAtom>
      <TextfieldDialogOrganism
        dialogRef={searchProductDialogRef}
        title='Escribe el código del producto'
        label='Código'
        confirmText='Continuar'
        cancelText='Cancelar'
        confirmAction={actions.searchProduct}
      />
    </PageContentAtom>
  </>
}

const InventoryProductListEmpty = () => {
  return (
    <div className="product-list-empty">
      <svg xmlns="http://www.w3.org/2000/svg"
           className="icon icon-tabler icon-tabler-mood-empty"
           viewBox="0 0 24 24" strokeWidth="1.5"
           stroke="currentColor" fill="none" strokeLinecap="round"
           strokeLinejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
        <path d="M9 10l.01 0" />
        <path d="M15 10l.01 0" />
        <path d="M9 15l6 0" />
      </svg>
      No hay productos en esta ubicación y/o contenedor
    </div>
  )
}
